module.exports = __webpack_public_path__ + "img/twism-dark.bc711061.svg";